import { render, staticRenderFns } from "./PatientRowCells.vue?vue&type=template&id=b394e21a"
import script from "./PatientRowCells.vue?vue&type=script&lang=js"
export * from "./PatientRowCells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports